import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Button, FullBox, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { ProposalsIllustration } from '../../pages/ProposalsDashboard/ProposalsIllustration';
import styles from './WithdrawnForEditingPage.module.scss';
export const GetWithdrawnForEditingPageTID = (parentTestId)=>getTestIds(parentTestId);
export const WithdrawnForEditingPage = (param)=>{
    let { testId, vendorName, onRefresh } = param;
    const { WithdrawnForEditingPageTestIds } = useMemo(()=>GetWithdrawnForEditingPageTID(testId), [
        testId
    ]);
    const { t: withdrawnForEditingPageTexts } = useLocaleKeys('pages.withdrawnForEditingPage');
    const businessName = vendorName || withdrawnForEditingPageTexts.defaultVendorName();
    return /*#__PURE__*/ _jsx(FullBox, {
        centered: true,
        flexDirection: "column",
        className: styles.root,
        testId: WithdrawnForEditingPageTestIds.Root(),
        children: /*#__PURE__*/ _jsxs(Box, {
            className: styles.container,
            children: [
                /*#__PURE__*/ _jsx(ProposalsIllustration, {}),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "h5",
                    weight: "normal",
                    className: styles.text,
                    testId: WithdrawnForEditingPageTestIds.Title(),
                    children: withdrawnForEditingPageTexts.title()
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    className: styles.text,
                    testId: WithdrawnForEditingPageTestIds.Body(),
                    children: withdrawnForEditingPageTexts.body({
                        businessName
                    })
                }),
                /*#__PURE__*/ _jsx(Button, {
                    bi: {
                        name: 'refresh_withdrawn_for_editing'
                    },
                    skin: "primary",
                    size: "medium",
                    testId: WithdrawnForEditingPageTestIds.RefreshButton(),
                    className: styles.refreshButton,
                    onClick: ()=>onRefresh ? onRefresh() : window.location.reload(),
                    children: withdrawnForEditingPageTexts.refreshButton()
                })
            ]
        })
    });
};
export default WithdrawnForEditingPage;
